import { CustomFormQuestion } from 'components/tools/CustomForm/types'

export const dynamicOptionsValidators = (options: string[], question: CustomFormQuestion): string => {
  let error = ''

  if (question?.validation) {
    if (question?.validation?.min) {
      if (options.length !== 0 && options.length < question?.validation?.min) {
        error = 'Opções mínimas não alcançado'
      }
    }

    if (question?.validation?.max) {
      if (options.length !== 0 && options.length > question?.validation?.max) {
        error = 'Opções máxima ultrapassada'
      }
    }
  }

  return error
}

type ValidateMultipleSelectionBoxOnCustomFormParams = {
  options: string[]
  question: CustomFormQuestion
}

export default function validateMultipleSelectionBoxOnCustomForm({
  options,
  question,
}: ValidateMultipleSelectionBoxOnCustomFormParams) {
  let error = ''
  if (question.is_required && options.length === 0) {
    error = 'Este campo é obrigatório'
  }
  if (options) {
    const errorMessage = dynamicOptionsValidators(options, question)
    if (errorMessage !== '') {
      error = errorMessage
    }
  }
  return error
}
